import { render } from "./OurTeam.vue?vue&type=template&id=76871952"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"

import "./OurTeam.vue?vue&type=style&index=0&id=76871952&lang=css"

import exportComponent from "C:\\Users\\a1bg493225\\Desktop\\logika\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__